import UserFeedbackPopup from './UserFeedbackPopup';

export default UserFeedbackPopup;
